<template>
  <div>
    <div class="note ">
      <span @click="showModal()" class="hand"><i class="bx bx-pencil font-size-16 text-primary hand mt-2 mb-4"></i> {{ $t("common.add-note") }}</span>
    </div>
    <em v-if="payload.note" class="mt-4" style="word-wrap:break-word;">
      <b>{{ $t("common.note") }}:</b>

      {{ payload.note | translate }}</em
    >

    <b-modal :id="'modal-add-note' + payload._id" centered :title="$t('common.add-note')" hide-footer>
      <div>
        <sweet-textarea class="mt-3" v-model="form.note" type="text" :isValid="true" layout="vertical" :placeholder="$t('common.note')" :rows="3" />
        <div class="text-right">
          <sweet-button @click="save()" variant="success" icon="mdi mdi-check" size="sm" buttonClass="ml-2 mt-4">
            {{ $t("common.save") }}
          </sweet-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import SweetTextarea from "@c/form/sweet-textarea";

export default {
  components: { SweetTextarea },
  props: ["store", "payload"],

  watch: {
    payload: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.form = { ...this.prepareFormForEdit(v, ["note"]) };
          if (this.form.note) {
            this.showNote = true;
          }
        }
      },
    },
  },
  data() {
    return {
      showNote: false,
      form: { note: undefined },
    };
  },
  methods: {
    async save() {
      try {
        this.payload = await this.$store.dispatch(`${this.store}/preparePayload`, { editedEntity: {}, form: this.form });
        await this.$store.dispatch(`${this.store}/updateNote`, { _id: this.payload._id, note: this.payload.note });
        this.$toast.success(this.$t("common.success"));

        this.$root.$emit("bv::hide::modal", "modal-add-note" + this.payload._id);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    showModal() {
      this.$root.$emit("bv::show::modal", "modal-add-note" + this.payload._id);
    },
  },
};
</script>
